import {
  Stack,
  Box,
  Avatar,
  Typography,
  Button,
  Card,
  CardContent,
  ImageListItem,
  Dialog,
  Slide,
  TextField,
  Divider,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { green, grey } from "@mui/material/colors";
import logo from "../images/logo/kalsoft_logo.png";
import less_work from "../images/images/less_work.jpg";
import { useState } from "react";
import { Close, Facebook, Google } from "@mui/icons-material";
import { replace, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {BaseHrmUrl} from './Constants';
import axios from 'axios'


function Home() {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(null);

  return (
    <Stack>
      <Box
        display={"flex"}
        bgcolor={grey[100]}
        height={60}
        borderRadius={1}
        alignItems={"center"}
      >
        <Avatar
          src={logo}
          alt="logo"
          sx={{ height: 64, width: 64, ml: 1 }}
        ></Avatar>
        <Typography variant="h5" fontSize={{xs:12, sm:13, md:14, lg:15}}>KALSOFT SYSTEMS</Typography>
        <Box ml={"auto"} display={"flex"} columnGap={1} mr={1}>
          <Button
            variant="outlined"
            sx={{ borderRadius: 4, }}
            size="small"
            onClick={() => {
              setOpen(true);
              setContent(<Login setOpen={setOpen} />);
            }}
          >
            Sign in
          </Button>
          <Button
            variant="outlined"
            sx={{ borderRadius: 4 }}
            size="small"
            onClick={() => {
              setOpen(true);
              setContent(<Signup setOpen={setOpen} />);
            }}
          >
            Sign up
          </Button>
        </Box>
      </Box>
      <Card sx={{ my: 3 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h3">Kalsoft Systems</Typography>
          <Box ml={"auto"} display={"flex"} columnGap={2} mr={2}>
            <Typography variant="h4">Best tools for your business</Typography>
          </Box>
          <Box display={"flex"} columnGap={2} mt={2} alignItems={"center"}>
            <ImageListItem sx={{ width: "40vw" }}>
              <img src={less_work}></img>
            </ImageListItem>
            <Stack>
              <Typography variant="h4">
                Customized for you ...only you!
              </Typography>
              <Typography
                variant="h5"
                sx={{ fontStyle: "italic" }}
                alignSelf={"center"}
              >
                With user-friendly UI
              </Typography>
            </Stack>
            <Dialog open={open} onClose={() => setOpen(false)}>
              {content}
            </Dialog>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
}

export default Home;

function Login(props) {
  const { setOpen } = props;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = (values) => {    
    async function loadData(values) {
      try {
        const response = await axios.post(`${BaseHrmUrl}/login/`,
          { ...values},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
       
      setLoading(false);
      if (response.status === 200) {
        navigate("home", { state: response.data, replace: true });
      } else {
        setError(response.data.message);
      }
      } catch (error) {
        alert(error.toJSON());
      }
    };
  loadData(values)
  }
    

  const handlePassReset = () => {
    navigate("resetpass", { replace: true });
  };
  const myForm = useFormik({
    initialValues: {
      username: "",
      pass: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Required"),
      pass: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      handleSignIn(values);
    },
  });

  return (
    <Slide in={true} timeout={"200ms"} unmountOnExit>
      <Card style={{ maxHeight: 600, overflow: "auto" }}>
        <CardContent sx={{ width: "40vw" }}>
          <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
            <IconButton
              sx={{ ml: "auto" }}
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            ><Close /></IconButton>
          </Box>
          <Stack display={"flex"} rowGap={2} justifyContent={"center"}>
            <Box
              display={"flex"}
              columnGap={2}
              mt={2}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Avatar
                src=""
                alt="Profile"
                sx={{ height: 64, width: 64, ml: 3 }}
              ></Avatar>
            </Box>
            <Button
              sx={{ borderRadius: 4 }}
              size="small"
              variant="outlined"
              fullWidth
              startIcon={<Google />}
            >
              Sign in with Google
            </Button>
            <Button
              sx={{ borderRadius: 4 }}
              size="small"
              variant="outlined"
              fullWidth
              startIcon={<Facebook />}
            >
              Sign in with Facebook
            </Button>
            <Divider variant="middle" />
            <form onSubmit={myForm.handleSubmit}>
              <Stack display={"flex"} rowGap={2} justifyContent={"center"}>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Username"
                    name="username"
                    id="username"
                    type="text"
                    size="small"
                    value={myForm.values.username}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.username && myForm.errors.username ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.username}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Password"
                    size="small"
                    name="pass"
                    id="pass"
                    type="password"
                    onChange={myForm.handleChange}
                    value={myForm.values.pass}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.pass && myForm.errors.pass ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.pass}
                    </Typography>
                  ) : null}
                  {error ? (
                    <Typography variant="body2" color="error">
                      {error}
                    </Typography>
                  ) : null}
                </Stack>
                <Box
                  display={"flex"}
                  columnGap={2}
                  mt={2}
                  justifyContent={"end"}
                  alignItems={"center"}
                >
                </Box>
                <LoadingButton
                  sx={{ borderRadius: 4 }}
                  size="small"
                  variant="contained"
                  type="submit"
                  loading={loading}
                >
                  Sign in
                </LoadingButton>
              </Stack>
            </form>
            <Button
              sx={{ borderRadius: 4 }}
              size="small"
              variant="text"
              onClick={handlePassReset}
            >
              forgot password
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Slide>
  );
}

function Signup(props) {
  const { setOpen } = props;
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSignUp = (values) => {
    async function loadData() {
      try {
        const response = await axios.post(`${BaseHrmUrl}/company`,
          { ...values },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
       
        if (response.status === 200) {
          navigate("register_company", { state: response.data, replace: true });
        } else {
          setError(response.data.message);
        }
      } catch (error) {
        alert("Error fetching deductions, No internet?");
      }
    };
  loadData()
  }

  const myForm = useFormik({
    initialValues: {
      company: "",
      branch: "",
      contact: "",
      address: "",
      department:"",
      section:"",
      email: "",
      town: "",
      pass: "",
    },
    validationSchema: Yup.object({
      company: Yup.string().required("Required").min(3, "Too short"),
      branch: Yup.string().required("Required").min(3, "Too short"),
      department: Yup.string().required("Required"),
      section: Yup.string().required("Required"),
      contact: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      town: Yup.string().required("Required").min(3, "Too short"),
      company: Yup.string().required("Required"),
      pass: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      handleSignUp(values);
    },
  });

  return (
    <Slide in={true} timeout={"200ms"} unmountOnExit>
      <Card style={{ maxHeight: 600, overflow: "auto" }}>
        <CardContent sx={{ width: "40vw" }}>
          <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
            <IconButton
              sx={{ ml: "auto" }}
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Stack display={"flex"} rowGap={2} justifyContent={"center"}>
            <Box
              display={"flex"}
              columnGap={2}
              mt={2}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Avatar
                src={logo}
                alt="Profile"
                sx={{ height: 96, width: 96, ml: 3 }}
              ></Avatar>
            </Box>

            <Divider variant="middle" />
            <form onSubmit={myForm.handleSubmit}>
              <Stack display={"flex"} rowGap={2} justifyContent={"center"}>
                {error ? (
                  <Typography variant="body2" color="error">
                    {error}
                  </Typography>
                ) : null}
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Company"
                    name="company"
                    id="company"
                    type="text"
                    size="small"
                    value={myForm.values.company}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.company && myForm.errors.company ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.company}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Branch"
                    name="branch"
                    id="branch"
                    type="text"
                    size="small"
                    value={myForm.values.branch}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.branch && myForm.errors.branch ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.branch}
                    </Typography>
                  ) : null}
                </Stack>
                <Box display={'flex'} justifyContent={'space-evenly'}>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Department"
                    name="department"
                    id="department"
                    type="text"
                    size="small"
                    value={myForm.values.department}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  
                  />
                  {myForm.touched.department && myForm.errors.department ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.department}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Section"
                    name="section"
                    id="section"
                    type="text"
                    size="small"
                    value={myForm.values.section}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.section && myForm.errors.section ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.section}
                    </Typography>
                  ) : null}
                </Stack>
                </Box>
                <Box display={'flex'} justifyContent={'space-evenly'}>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Address"
                    name="address"
                    id="address"
                    type="text"
                    size="small"
                    value={myForm.values.address}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.address && myForm.errors.address ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.address}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Primary Contact"
                    name="contact"
                    id="contact"
                    type="text"
                    size="small"
                    value={myForm.values.contact}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.contact && myForm.errors.contact ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.contact}
                    </Typography>
                  ) : null}
                </Stack>
                </Box>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Primary Email"
                    name="email"
                    id="email"
                    type="text"
                    size="small"
                    value={myForm.values.email}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.contact && myForm.errors.contact ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.contact}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Town"
                    name="town"
                    id="town"
                    type="text"
                    size="small"
                    value={myForm.values.town}
                    onChange={myForm.handleChange}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.town && myForm.errors.town ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.town}
                    </Typography>
                  ) : null}
                </Stack>

                <Stack>
                  <TextField
                    sx={{ borderRadius: 4 }}
                    label="Password"
                    size="small"
                    name="pass"
                    id="pass"
                    type="password"
                    onChange={myForm.handleChange}
                    value={myForm.values.pass}
                    onBlur={myForm.handleBlur}
                    fullWidth
                  />
                  {myForm.touched.pass && myForm.errors.pass ? (
                    <Typography variant="body2" color="error">
                      {myForm.errors.pass}
                    </Typography>
                  ) : null}
                </Stack>
                <LoadingButton
                  sx={{ borderRadius: 4 }}
                  size="small"
                  variant="contained"
                  type="submit"
                  loading={loading}
                >
                  Create
                </LoadingButton>
              </Stack>
            </form>
          </Stack>
        </CardContent>
      </Card>
    </Slide>
  );
}
